import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";

export default function NotFound() {
  const { t, lang } = useI18n();
  return (
    <section className="py-24 text-center">
      <div className="max-w-md mx-auto px-5">
        <div className="font-serif text-6xl text-[#0F2447]">404</div>
        <p className="mt-4 text-[#3d4757]">{t("footer.disclaimer")}</p>
        <Link to={`/${lang}`} className="mt-6 inline-block bg-[#B85D3D] text-white px-6 py-3 text-sm uppercase tracking-widest rounded">
          {t("footer.links.home")}
        </Link>
      </div>
    </section>
  );
}
